import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  wrapper: {
    backgroundColor: "transparent",
    paddingTop: "0.25rem",
    paddingRight: "0.25rem",
    color: "##373534",
    fontFamily: "Inter",
    fontWeight: 600,
    fontSize: "16px",
    display: "flex"
  },
  isHovered: {
    backgroundColor: theme.palette.primary.primary50,
  },
  isHoveredSimple : {
    cursor: 'pointer',
  }
}));

export default useStyles;
